import { render } from "./gang-change-fop.vue?vue&type=template&id=12473e75"
import script from "./gang-change-fop.vue?vue&type=script&lang=js"
export * from "./gang-change-fop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__